import { deleteAllCookies, getCookieByName, setCookieByName } from 'vendor/application';

const access = getCookieByName('d__ac');

const initialState = {
    access: { access: '', refresh: '', isAccess: false, userId: '' },
    notify: { message: '', severity: '', isNotify : false },
    initApp: false,
    isSending: false,
    projects: {},
    layouts: {} ,
    updateProjects : false
  }

  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_STATE': {
        return { ...state }
      }

      case 'UPDATE_PROJECTS_STATUS': {
        return {
          ...state,
          updateProjects: action.data
        }
      }
      
      case 'UPDATE_ACCESS_STATUS': {
        setCookieByName(action.data, 'd__ac' );
        return {
          ...state,
          access: action.data
        }
      }

      case 'SHOW_NOTIFY': {
        return {
          ...state,
          notify: { message: action.data.message, severity: action.data.severity, isNotify: true }
        }
      }

      case 'HIDE_NOTIFY': {
        return {
          ...state,
          notify: { message: action.data.message, severity: action.data.severity, isNotify: false }
        }
      }

      case 'UPDATE_LAYOUTS': {
        return {
          ...state,
          layouts: action.data
        }
      }

      case 'UPDATE_SENDING': {
        return {
          ...state,
          isSending: action.data
        }
      }

      case 'UPDATE_PROJECTS': {
        return {
          ...state,
          projects: action.data
        }
      }

      case 'UPDATE_INIT_APP': {
        return {
          ...state,
          initApp: action.data
        }
      }

      case 'RESET_STATE': {
        deleteAllCookies();
        return initialState;
      }

      default: {
        if ( access ) { state = { ...state, access } }
        return state;
      }
    }
  }
  
  export default reducer;
  